module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/inputs/spk-select/spk-select.component.scss
// module id = ./src/app/components/framework/spk/inputs/spk-select/spk-select.component.scss
// module chunks = main